// Import the RTK Query methods from the React-specific entry point
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { Chain, FormDefinition, Lead, SalesPerson } from './interfaces'
import { formId, lang, apiUrl } from '../../dom'

export const apiSlice = createApi({
    reducerPath: 'v1',
    baseQuery: fetchBaseQuery({ baseUrl: `${apiUrl}v1` }),
    endpoints: builder => ({
        getChains: builder.query<Chain[], void>({
            query: () => `/chains`
        }),
        getFormById: builder.query<FormDefinition, string>({
            query: () => `/forms/${formId}/?lang=${lang}`
        }),
        getLeadByToken: builder.query<Lead, string>({
            query: (token) => `/forms/${formId}/leads/${token}`,
        }),
        createLead: builder.mutation({
            query: (data) => ({
                url: `/forms/${formId}/leads/`,
                method: 'POST',
                body: data,
            })
        }),
        submitLead: builder.mutation({
            query: ({token, ...data}) => ({
                url: `/forms/${formId}/leads/${token}/submit`,
                method: 'POST',
                body: data,
            })
        }),
        updateLead: builder.mutation({
            query: ({token, ...patch}) => ({
                url: `/forms/${formId}/leads/${token}`,
                method: 'PATCH',
                body: patch,
            }),
            async onQueryStarted({ token, ...patch }, { dispatch, queryFulfilled }) {
                const patchResult = dispatch(
                    apiSlice.util.updateQueryData('getLeadByToken', token, (draft) => {
                        if (!draft.values) {
                            draft.values = {}
                        }
                        Object.assign(draft.values, patch)
                    })
                )
                try {
                    await queryFulfilled
                } catch {
                    patchResult.undo()
                }
            },
        }),
    })
})

// Export the auto-generated hook for the `getPosts` query endpoint
export const {
    useGetChainsQuery,
    useGetFormByIdQuery,
    useGetLeadByTokenQuery,
    useCreateLeadMutation,
    useUpdateLeadMutation,
    useSubmitLeadMutation,
    usePrefetch,
} = apiSlice
